var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3a1 1 0 01.117 1.993L10 5H3a1 1 0 00-.993.883L2 6v14a1 1 0 00.883.993L3 21h14a1 1 0 00.993-.883L18 20v-7a1 1 0 011.993-.117L20 13v7a3 3 0 01-2.824 2.995L17 23H3a3 3 0 01-2.995-2.824L0 20V6a3 3 0 012.824-2.995L3 3h7zm6.793-1.207l-9.5 9.5a1 1 0 00-.263.464l-1 4a1 1 0 001.213 1.213l4-1a1 1 0 00.464-.263l9.5-9.5a3.121 3.121 0 00-4.414-4.414zm3.087 1.512c.349.44.32 1.081-.087 1.488l-9.305 9.303-2.114.529.529-2.114 9.304-9.304a1.121 1.121 0 011.586 0l.087.098z",
    fill: "#596F85",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.16a7ff6e7445e9e016cd7aa23d49e202.svg";
export { ForwardRef as ReactComponent };